module.exports = __webpack_public_path__ + "static/img/tj4.f859d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj4.png
// module id = UsOn
// module chunks = 1